export enum RadioButtonVariant {
  DEFAULT = 'default',
  COMPACT = 'compact',
}